export default __webpack_public_path__ + "static/media/unfinished-part.c1260bf1.png";